export const de = {
  nav_servizi: "Leistungen",
  nav_brand: "Marken",
  nav_recensioni: "Bewertungen",
  nav_contatti: "Kontakt",
  nav_faq: "FAQ",
  cta_prenota: "Termin buchen",
  hero_overline: "Optik · Ceglie Messapica",
  hero_l1: "Stil",
  hero_l2a: "trifft",
  hero_l2b: "auf Sehkraft.",
  hero_sub: "Seit über 13 Jahren die Referenz-Optik im Herzen des Valle d'Itria: Sonnenbrillen und Korrektionsbrillen, Kinder- und Gleitsichtgläser. Via Cristoforo Colombo 40, Ceglie Messapica.",
  hero_cta1: "Termin buchen",
  hero_cta_shop: "Kollektion entdecken",
  hero_cta2: "Unsere Leistungen",
  hero_proof: "5,0 auf Google · 35 Bewertungen",
  cfg_shape: "Fassung",
  cfg_color: "Farbe",
  cfg_lens: "Gläser",
  shape_rotonda: "Rund",
  shape_squadrata: "Eckig",
  shape_pantos: "Panto",
  shape_aviator: "Aviator",
  shape_cateye: "Cat-Eye",
  col_nero: "Schwarz",
  col_avana: "Havanna",
  col_terracotta: "Terrakotta",
  col_oliva: "Oliv",
  col_oro: "Gold",
  lens_cristallo: "Kristall",
  lens_verde: "Grün",
  lens_ambra: "Bernstein",
  lens_fume: "Rauchgrau",
  lens_azzurra: "Himmelblau",
  man_statement: "Brillen für alle, die einzigartig sein wollen.",
  man_highlight: "einzigartig.",
  man_c1t: "Dreizehn Jahre vor Ort",
  man_c1d: "Seit über dreizehn Jahren in Ceglie Messapica: eine Referenz-Optik, in der Professionalität und Herzlichkeit regieren.",
  man_c2t: "Seh-Spezialisten",
  man_c2d: "Korrekturgläser für Kinder mit zertifiziertem Myopie-Management und Gleitsichtgläser für Erwachsene: gutes Sehen in jedem Alter.",
  man_c3t: "Sorgsam gewählte Marken und Räume",
  man_c3d: "Die Auswahl der Marken und der Einrichtung ist unsere Stärke: alles ist für Menschen gedacht, die sich einzigartig fühlen wollen.",
  man_alt: "Editorial-Porträt mit Korrektionsbrille",
  cert_label: "Zertifizierungen",
  cert1t: "Expert Specialist Optikzentrum",
  cert2t: "Zertifiziertes Myopie-Management",
  srv_overline: "01 · Unsere Leistungen",
  srv_title: "Alles für Ihre Augen, an einem Ort.",
  srv1t: "Sonnenbrillen",
  srv1d: "Sorgfältig ausgewählte Erwachsenen-Kollektionen: von zeitlosen Klassikern bis zu den neuesten Trends.",
  srv2t: "Korrektionsbrillen",
  srv2d: "Maßgeschneiderte Fassungen und Korrekturgläser, mit absoluter Präzision.",
  srv3t: "Kindergläser",
  srv3d: "Korrekturgläser für die Kleinsten und zertifiziertes Myopie-Management mit Stellest-Gläsern.",
  srv4t: "Gleitsichtgläser",
  srv4d: "Für Erwachsene: fließender Übergang zwischen Nah und Fern, ohne Kompromisse.",
  srv5t: "Lieferung und Abholung",
  srv5d: "Lieferung nach Hause oder Abholung im Geschäft: wie Sie möchten, ohne Wartezeit.",
  srv_store_t: "Einkaufen im Geschäft",
  srv_store_d: "Besuchen Sie uns: Probieren Sie die Fassungen mit der Beratung unserer Optiker. Schneller Besuch, unverbindlich.",
  srv_store_alt: "Innenraum der Boutique Stylottica Ceglie",
  stmt_label: "Unsere Philosophie",
  stmt_w1: "Lieber",
  stmt_w2: "einzigartig",
  stmt_w3: "als langweilig.",
  brand_overline: "02 · Marken & Stile",
  brand_title: "Die Fassungen, die Sie lieben, auch für die Jüngsten.",
  brand_sub: "Bei Stylottica Ceglie finden Sie die Police-Brillen für Teenager und viele weitere Modelle für jedes Alter und jeden Stil.",
  mq_sole: "Sonnenbrillen",
  mq_vista: "Korrektionsbrillen",
  mq_contatto: "Kontaktlinsen",
  mq_teen: "Teenager-Fassungen",
  mq_nuove: "Neue Kollektionen",
  vet_overline: "03 · Auslage",
  vet_title: "Die Fassungen des Moments.",
  vet_sub: "Eine Auswahl der im Geschäft verfügbaren Modelle. Wählen Sie eine Kollektion und kommen Sie zum Anprobieren vorbei.",
  vet_all: "Alle",
  vet_empty: "In dieser Kollektion gibt es im Moment keine Modelle. Schauen Sie bald wieder vorbei.",
  vet_add: "In den Warenkorb",
  vet_out: "Ausverkauft",
  vet_unavailable: "Nicht verfügbar",
  vet_avail: "Im Geschäft verfügbar",
  vet_last: "Nur noch {n} Stück",
  vet_last1: "Letztes Stück",
  promo_label: "Aktuelle Aktion",
  promo_cta: "Im Geschäft nutzen",
  promo_valid: "Gültig bis",
  promo_da: "Gültig ab",
  rev_overline: "04 · Das sagen unsere Kunden",
  rev_caption: "Die Bestnote unserer Kunden auf Google",
  rev_stat1: "Google · 35 Bewertungen",
  rev_stat2: "Facebook · 46 Bewertungen",
  rev_stat3: "Follower auf Facebook",
  rev_closing: "Das Vertrauen unserer Kunden ist unsere beste Linse. Kommen Sie vorbei und entdecken Sie, warum wer einmal bei Stylottica Ceglie war, immer wiederkommt.",
  testimonials: [
    { text: "Seltene Professionalität und Freundlichkeit. Sie haben mir geholfen, die perfekte Fassung für mein Gesicht zu finden.", name: "Maria G." },
    { text: "Brille in kürzester Zeit fertig und ein makelloses Ergebnis. Ich komme auf jeden Fall wieder.", name: "Giuseppe L." },
    { text: "Endlich ein Optiker, der wirklich zuhört. Sehr präziser Sehtest.", name: "Anna S." },
    { text: "Ich habe die Police-Brille für meinen Sohn gekauft: Er ist überglücklich und setzt sie nie ab.", name: "Francesca M." },
    { text: "Ehrliche Preise, große Auswahl und aufrichtige Beratung. Sehr empfehlenswert.", name: "Marco P." },
    { text: "Elegantes Ambiente und bestens geschultes Personal. Der beste Optiker der Gegend.", name: "Lucia R." },
  ],
  con_overline: "07 · Kontakt & Öffnungszeiten",
  con_directions: "Anfahrt",
  con_title: "Wir freuen uns auf Sie im Geschäft.",
  con_hours: "Öffnungszeiten",
  day_mon: "Montag",
  day_tuesat: "Dienstag – Samstag",
  day_sun: "Sonntag",
  mon_note: "Vormittags geschlossen",
  closed: "Geschlossen",
  con_phone_note: "(auch WhatsApp)",
  con_form_t: "Schreiben Sie uns",
  con_form_s: "Um einen Termin zu buchen oder Fragen zu den Kollektionen zu stellen.",
  ph_name: "Vor- und Nachname",
  ph_phone: "Telefon (optional)",
  ph_msg: "Ihre Nachricht",
  btn_send: "Nachricht senden",
  btn_sending: "Wird gesendet…",
  toast_ok: "Nachricht gesendet! Wir melden uns so bald wie möglich.",
  toast_err: "Fehler beim Senden. Versuchen Sie es erneut oder rufen Sie uns an: 0831 19 81 780.",
  footer_tag: "Optik in Ceglie Messapica. Via Cristoforo Colombo 40, 72013 (BR).",
  footer_hours1: "Mo – Sa · 09:00 – 12:45 / 17:30 – 20:00",
  footer_hours2: "Montagvormittag geschlossen · Sonntag geschlossen",
  footer_admin: "Interner Bereich",
  footer_rights: "Alle Rechte vorbehalten",
  footer_banner: "Im weißen Herzen des Valle d'Itria",
  footer_banner_alt: "Gasse von Ceglie Messapica bei Sonnenuntergang",
  wa_label: "Schreiben Sie uns",
  cart_title: "Ihr Warenkorb",
  cart_empty: "Der Warenkorb ist leer. Wählen Sie eine Fassung aus der Auslage.",
  cart_total: "Gesamt",
  cart_ph_note: "Anmerkungen (optional)",
  cart_submit: "Bestätigen und per WhatsApp senden",
  cart_sending: "Wird gesendet…",
  cart_note: "Die Zahlung wird im Geschäft oder per WhatsApp vereinbart. Keine Online-Zahlung erforderlich.",
  cart_toast_ok: "Bestellung registriert! WhatsApp hat sich mit der Zusammenfassung geöffnet: senden Sie sie zur Bestätigung.",
  cart_toast_err: "Fehler beim Senden der Bestellung. Bitte erneut versuchen.",
  cart_close: "Schließen",
  cart_minus: "Weniger",
  cart_plus: "Mehr",
  cart_remove: "Entfernen",
  cart_open: "Warenkorb",
  faq_overline: "05 · Häufige Fragen",
  faq_overline_plain: "Häufige Fragen",
  faq_title: "Die Antworten, die Sie suchen.",
  faqs: [
    { q: "Muss ich zum Anprobieren einen Termin buchen?", a: "Nein: Kommen Sie jederzeit während der Öffnungszeiten vorbei und probieren Sie die Fassungen frei aus. Wenn Sie eine persönliche Beratung wünschen, buchen Sie einen Termin und wir nehmen uns alle Zeit für Sie." },
    { q: "Machen Sie Sehtests im Geschäft?", a: "Ja, wir führen den Sehtest direkt im Geschäft durch. Als Essilor Expert Specialist Optikzentrum folgen wir einem präzisen Protokoll, für perfekte Gläser von der ersten Nutzung an." },
    { q: "Wie lange dauert es, bis meine Brille fertig ist?", a: "In den meisten Fällen nur wenige Werktage. Bei speziellen Gläsern oder Veredelungen kann es variieren: Wir nennen Ihnen immer ein genaues Datum bei der Bestellung." },
    { q: "Haben Sie Brillen für Kinder?", a: "Ja, wir sind auf Korrekturgläser für die Kleinsten spezialisiert und für das Myopie-Management mit Stellest-Gläsern zertifiziert. Wir begleiten jedes Kind über die Zeit, mit regelmäßigen Kontrollen." },
    { q: "Kann ich online bestellen und im Geschäft abholen?", a: "Ja: Wählen Sie die Modelle in der Auslage, bestätigen Sie die Bestellung per WhatsApp und holen Sie sie ab, wann Sie möchten. Auf Wunsch liefern wir auch nach Hause." },
    { q: "Welche Zahlungsmethoden akzeptieren Sie?", a: "Im Geschäft akzeptieren wir Bargeld, EC- und Kreditkarten. Bei Online-Bestellungen wird die Zahlung per WhatsApp oder bei der Abholung vereinbart." },
  ],
  book_overline: "06 · Termin buchen",
  book_title: "Buchen Sie Ihren Termin.",
  book_sub: "Wählen Sie Tag und Uhrzeit: Sie können ab 2 Tagen im Voraus buchen, damit wir uns bestens auf Sie vorbereiten können. Wir bestätigen Ihren Termin so bald wie möglich.",
  book_phone: "Telefon",
  book_service: "Leistung",
  book_service_ph: "Leistung wählen",
  svc_vista: "Sehtest",
  svc_occhiali: "Beratung Korrektionsbrillen",
  svc_sole: "Sonnenbrillen",
  svc_bambini: "Kindergläser · Myopie-Management",
  svc_progressive: "Gleitsichtgläser",
  svc_altro: "Sonstiges",
  svc_lenti_prima: "Erste Kontaktlinsen-Anpassung",
  svc_lenti_controllo: "Kontaktlinsen-Kontrolle / Erneuerung",
  book_ambito: "Worum geht es?",
  book_ambito_first: "Wählen Sie zuerst den Bereich",
  ambito_vista: "Korrektionsbrillen",
  ambito_vista_sub: "Sehtest & Brillen",
  ambito_lenti: "Kontaktlinsen",
  ambito_lenti_sub: "Anpassung & Kontrolle",
  book_banner_overline: "Ihre Augen in guten Händen",
  book_banner_title: "Buchen Sie Ihren Besuch.",
  book_banner_sub: "Sehtest, Korrektionsbrillen oder Kontaktlinsen-Anpassung: Vereinbaren Sie einen Termin und wir nehmen uns alle Zeit, die Sie brauchen.",
  book_banner_cta: "Jetzt buchen",
  spec_lenti: "Gläser",
  spec_taglia: "Größe",
  book_date: "Tag",
  book_slot: "Uhrzeit",
  book_submit: "Termin anfragen",
  book_sending: "Wird gesendet…",
  book_sunday: "Sonntags haben wir geschlossen: bitte wählen Sie einen anderen Tag.",
  book_monday: "Montags haben wir nur nachmittags geöffnet (17:30 – 20:00).",
  book_toast_ok: "Anfrage registriert! WhatsApp hat sich mit der Zusammenfassung geöffnet: senden Sie sie zur Bestätigung des Termins.",
  book_toast_err: "Fehler beim Senden. Versuchen Sie es erneut oder rufen Sie uns an: 0831 19 81 780.",
  privacy_note: "Mit dem Absenden akzeptieren Sie unsere",
  privacy_link: "Datenschutzerklärung",
  book_consent: "Ich habe die Verarbeitung meiner Daten zur Bearbeitung der Terminanfrage gelesen und akzeptiere sie gemäß der",
  tryon_btn: "Virtuelle Anprobe",
  tryon_title: "Virtuelle Anprobe",
  tryon_sub: "Sehen Sie, wie sie Ihnen steht:",
  tryon_use_camera: "Selfie aufnehmen",
  tryon_use_upload: "Foto hochladen",
  tryon_capture: "Aufnehmen",
  tryon_cancel: "Abbrechen",
  tryon_start: "Brille an mir sehen",
  tryon_change: "Anderes Foto",
  tryon_loading: "Die KI setzt die Brille auf Ihr Gesicht… das kann bis zu einer Minute dauern.",
  tryon_retry: "Anderes Foto versuchen",
  tryon_done: "Fertig",
  tryon_mode_single: "Dieses Modell",
  tryon_mode_compare: "Modelle vergleichen",
  tryon_pick_sub: "Wählen Sie 2 bis 4 Modelle, die Sie gemeinsam anprobieren möchten:",
  tryon_pick_min: "Wählen Sie mindestens 2 Modelle zum Vergleichen",
  tryon_compare_start: "An meinem Gesicht vergleichen",
  tryon_compare_loading: "Die KI setzt alle Modelle auf Ihr Gesicht... das kann etwa eine Minute dauern.",
  tryon_download: "Herunterladen",
  tryon_added: "In den Warenkorb gelegt",
  tryon_error: "Virtuelle Anprobe fehlgeschlagen. Bitte mit einem anderen Foto versuchen.",
  tryon_camera_err: "Kamera nicht verfügbar: bitte laden Sie ein Foto hoch.",
  tryon_privacy: "Ihr Foto wird nur zur Erstellung der Vorschau verwendet und niemals gespeichert oder geteilt.",
  tryon_result_alt: "Vorschau der Brille auf Ihrem Gesicht",
  hl_1: "Zertifizierte Optometristen",
  hl_2: "Spezialisten für Kinderoptik",
  hl_3: "Gleitsichtgläser",
  hl_4: "Nischenmarken",
  chi_overline: "Über uns",
  chi_photo_alt: "Die Inhaber von Stylottica Ceglie in ihrer Boutique",
  v2_nav_collezioni: "Kollektionen",
  v2_nav_storia: "Unsere Geschichte",
  v2_nav_prodotti: "Produkte",
  v2_nav_contatti: "Kontakt",
  v2_hero_overline: "Optik · Ceglie Messapica",
  v2_hero_suffix: " · seit 2012",
  v2_hero_title: "Die Kunst, gut zu sehen.",
  v2_hero_sub: "Im weißen Herzen von Ceglie Messapica, seit 2012: Sonnenbrillen mit Charakter, auch online erhältlich, und eine Sehpflege, die wir gemeinsam aufbauen — in Ruhe, mit Termin.",
  v2_hero_cta: "Kollektionen entdecken",
  v2_coll_overline: "Die Kollektionen",
  v2_coll_sole_desc: "Voller UV-Schutz und jede Menge Charakter. Online auswählen, im Geschäft abholen — oder wir liefern nach Hause.",
  v2_coll_vista_desc: "Sehkraft ist eine ernste Sache: sie wird in Ruhe gemessen, mit den richtigen Instrumenten. Buchen Sie Ihren Termin und wir bauen Ihre Gläser gemeinsam.",
  v2_scopri: "Entdecken",
  v2_storia_overline: "Unsere Geschichte",
  v2_storia_title: "Dreizehn Jahre voller Blicke.",
  v2_storia_p1: "Alles begann vor dreizehn Jahren, in einer Straße im Zentrum von Ceglie Messapica. Seitdem empfangen wir jeden, der hereinkommt, wie Familie: zuerst hören wir uns Ihre Tage, Ihre Augen, Ihre Gewohnheiten an — dann beraten wir. Denn die richtige Brille verändert, wie Sie die Welt sehen und wie die Welt Sie sieht.",
  v2_storia_p2: "Wir sind zertifizierte Optometristen und Essilor Expert Specialist Optikzentrum. Wir kümmern uns um das Sehen der Kleinsten mit zertifiziertem Myopie-Management und Stellest-Gläsern, fertigen Gleitsichtgläser maßgeschneidert für Ihren Alltag und wählen Nischenmarken aus, die Sie anderswo nicht finden — mit derselben Sorgfalt, mit der wir für uns selbst wählen würden.",
  v2_quote: "Professionalität und Herzlichkeit regieren hier.",
  v2_mission_label: "Unsere Mission",
  v2_mission: "Brillen für alle, die einzigartig sein wollen. Nie billig, nie langweilig.",
  v2_stat1: "Jahre Tätigkeit",
  v2_stat2: "Optische Zertifizierungen",
  v2_stat3: "Auf Google",
  v2_prod_overline: "Die Produkte",
  v2_prod_sub: "Unsere Sonnenbrillen, einzeln ausgewählt von den Nischenmarken, die wir lieben: online bestellen und abholen, wann Sie möchten, oder schreiben Sie uns auf WhatsApp. Für Korrektionsbrillen sehen wir uns persönlich — Ihre Sehkraft verdient mehr als einen Klick.",
  v2_prod_cta: "Verfügbarkeit anfragen",
  v2_coll_overline: "Die Kollektionen",
  v2_coll_instore: "Nur im Geschäft",
  v2_empty: "Die Auslage füllt sich gerade. Schauen Sie bald wieder vorbei.",
  v2_show_all: "Alle Produkte ansehen",
  v2_show_less: "Weniger anzeigen",
  v2_version1: "Version 1",
  v2_version2: "Version 2",
};

export const fr = {
  nav_servizi: "Services",
  nav_brand: "Marques",
  nav_recensioni: "Avis",
  nav_contatti: "Contact",
  nav_faq: "FAQ",
  cta_prenota: "Réserver",
  hero_overline: "Optique · Ceglie Messapica",
  hero_l1: "Le style",
  hero_l2a: "rencontre",
  hero_l2b: "la vision.",
  hero_sub: "Depuis plus de 13 ans, l'optique de référence au cœur de la Valle d'Itria : lunettes de soleil et de vue, verres pour enfants et progressifs. Via Cristoforo Colombo 40, Ceglie Messapica.",
  hero_cta1: "Réserver une visite",
  hero_cta_shop: "Découvrir la Collection",
  hero_cta2: "Découvrir nos services",
  hero_proof: "5,0 sur Google · 35 avis",
  cfg_shape: "Monture",
  cfg_color: "Couleur",
  cfg_lens: "Verres",
  shape_rotonda: "Ronde",
  shape_squadrata: "Carrée",
  shape_pantos: "Pantos",
  shape_aviator: "Aviator",
  shape_cateye: "Cat-eye",
  col_nero: "Noir",
  col_avana: "Havane",
  col_terracotta: "Terracotta",
  col_oliva: "Olive",
  col_oro: "Or",
  lens_cristallo: "Cristal",
  lens_verde: "Vert",
  lens_ambra: "Ambre",
  lens_fume: "Fumé",
  lens_azzurra: "Bleu ciel",
  man_statement: "Des lunettes pour ceux qui choisissent d'être uniques.",
  man_highlight: "uniques.",
  man_c1t: "Treize ans sur le territoire",
  man_c1d: "Depuis plus de treize ans à Ceglie Messapica : une optique de référence où professionnalisme et empathie règnent en maîtres.",
  man_c2t: "Spécialistes de la vision",
  man_c2d: "Verres ophtalmiques pour enfants avec gestion certifiée de la myopie et verres progressifs pour adultes : la vue à tout âge.",
  man_c3t: "Marques et espaces choisis avec soin",
  man_c3d: "Le choix des marques et de l'aménagement est notre force : tout est pensé pour celles et ceux qui veulent se sentir uniques.",
  man_alt: "Portrait éditorial avec lunettes de vue",
  cert_label: "Certifications",
  cert1t: "Centre Optique Expert Specialist",
  cert2t: "Gestion de la myopie certifiée",
  srv_overline: "01 · Nos services",
  srv_title: "Tout pour vos yeux, en un seul endroit.",
  srv1t: "Lunettes de soleil",
  srv1d: "Collections adultes sélectionnées avec soin : des classiques intemporels aux dernières tendances.",
  srv2t: "Lunettes de vue",
  srv2d: "Montures et verres ophtalmiques sur mesure, avec une attention absolue à la précision.",
  srv3t: "Verres pour enfants",
  srv3d: "Verres ophtalmiques pour les plus petits et gestion certifiée de la myopie avec les verres Stellest.",
  srv4t: "Verres progressifs",
  srv4d: "Pour adultes : passage fluide entre près et loin, sans compromis.",
  srv5t: "Livraison et retrait",
  srv5d: "Livraison à domicile ou retrait en boutique : comme vous préférez, sans attente.",
  srv_store_t: "Shopping en boutique",
  srv_store_d: "Venez nous voir : essayez les montures avec les conseils de nos opticiens. Visite rapide, sans engagement.",
  srv_store_alt: "Intérieur de la boutique Stylottica Ceglie",
  stmt_label: "Notre philosophie",
  stmt_w1: "Plutôt",
  stmt_w2: "uniques",
  stmt_w3: "qu'ennuyeux.",
  brand_overline: "02 · Marques & Styles",
  brand_title: "Les montures que vous aimez, même pour les plus jeunes.",
  brand_sub: "Chez Stylottica Ceglie, trouvez les lunettes Police pensées pour les adolescents et bien d'autres propositions pour chaque âge et style.",
  mq_sole: "Lunettes de Soleil",
  mq_vista: "Lunettes de Vue",
  mq_contatto: "Lentilles de Contact",
  mq_teen: "Montures Ados",
  mq_nuove: "Nouvelles Collections",
  vet_overline: "03 · Vitrine",
  vet_title: "Les montures du moment.",
  vet_sub: "Une sélection des modèles disponibles en boutique. Choisissez une collection et passez les essayer.",
  vet_all: "Toutes",
  vet_empty: "Aucun modèle dans cette collection pour le moment. Revenez bientôt.",
  vet_add: "Ajouter au panier",
  vet_out: "Épuisé",
  vet_unavailable: "Non disponible",
  vet_avail: "Disponible en boutique",
  vet_last: "Plus que {n} pièces",
  vet_last1: "Dernière pièce",
  promo_label: "Promo en cours",
  promo_cta: "Profitez-en en boutique",
  promo_valid: "Valable jusqu'au",
  promo_da: "Valable du",
  rev_overline: "04 · Ils parlent de nous",
  rev_caption: "La note maximale de nos clients sur Google",
  rev_stat1: "Google · 35 avis",
  rev_stat2: "Facebook · 46 avis",
  rev_stat3: "Abonnés sur Facebook",
  rev_closing: "La confiance de nos clients est notre meilleur verre. Venez nous voir et découvrez pourquoi qui entre chez Stylottica Ceglie revient toujours.",
  testimonials: [
    { text: "Professionnalisme et gentillesse rares. Elles m'ont aidée à choisir la monture parfaite pour mon visage.", name: "Maria G." },
    { text: "Lunettes prêtes en très peu de temps et résultat impeccable. Je reviendrai certainement.", name: "Giuseppe L." },
    { text: "Enfin un opticien qui écoute vraiment. Mesure de la vue très précise.", name: "Anna S." },
    { text: "J'ai pris les lunettes Police pour mon fils : il est ravi et ne les quitte jamais.", name: "Francesca M." },
    { text: "Prix honnêtes, grand choix et conseils sincères. Très recommandé.", name: "Marco P." },
    { text: "Cadre élégant et personnel très compétent. Le meilleur opticien de la région.", name: "Lucia R." },
  ],
  con_overline: "07 · Contact & Horaires",
  con_directions: "Comment venir",
  con_title: "Nous vous attendons en boutique.",
  con_hours: "Horaires d'ouverture",
  day_mon: "Lundi",
  day_tuesat: "Mardi – Samedi",
  day_sun: "Dimanche",
  mon_note: "Fermé le matin",
  closed: "Fermé",
  con_phone_note: "(aussi WhatsApp)",
  con_form_t: "Écrivez-nous un message",
  con_form_s: "Pour réserver une visite ou demander des informations sur les collections.",
  ph_name: "Nom et prénom",
  ph_phone: "Téléphone (facultatif)",
  ph_msg: "Votre message",
  btn_send: "Envoyer le message",
  btn_sending: "Envoi en cours…",
  toast_ok: "Message envoyé ! Nous vous recontactons au plus vite.",
  toast_err: "Erreur lors de l'envoi. Réessayez ou appelez-nous au 0831 19 81 780.",
  footer_tag: "Optique à Ceglie Messapica. Via Cristoforo Colombo 40, 72013 (BR).",
  footer_hours1: "Lun – Sam · 09:00 – 12:45 / 17:30 – 20:00",
  footer_hours2: "Lundi matin fermé · Dimanche fermé",
  footer_admin: "Espace réservé",
  footer_rights: "Tous droits réservés",
  footer_banner: "Au cœur blanc de la Valle d'Itria",
  footer_banner_alt: "Ruelle de Ceglie Messapica au coucher du soleil",
  wa_label: "Écrivez-nous",
  cart_title: "Votre panier",
  cart_empty: "Le panier est vide. Choisissez une monture dans la vitrine.",
  cart_total: "Total",
  cart_ph_note: "Notes (facultatif)",
  cart_submit: "Confirmer et envoyer sur WhatsApp",
  cart_sending: "Envoi en cours…",
  cart_note: "Le paiement se fait en boutique ou sur WhatsApp. Aucun paiement en ligne requis.",
  cart_toast_ok: "Commande enregistrée ! WhatsApp s'est ouvert avec le récapitulatif : envoyez-le pour confirmer.",
  cart_toast_err: "Erreur lors de l'envoi de la commande. Réessayez.",
  cart_close: "Fermer",
  cart_minus: "Diminuer",
  cart_plus: "Augmenter",
  cart_remove: "Retirer",
  cart_open: "Panier",
  faq_overline: "05 · Questions fréquentes",
  faq_overline_plain: "Questions fréquentes",
  faq_title: "Les réponses que vous cherchez.",
  faqs: [
    { q: "Faut-il réserver pour essayer des lunettes ?", a: "Non : passez quand vous voulez aux horaires d'ouverture et essayez librement les montures. Si vous préférez un conseil dédié, réservez une visite et nous vous consacrerons tout le temps nécessaire." },
    { q: "Faites-vous la mesure de la vue en boutique ?", a: "Oui, nous effectuons la mesure de la vue directement en boutique. En tant que Centre Optique Expert Specialist Essilor, nous suivons un protocole précis, pour des verres parfaits dès la première utilisation." },
    { q: "Combien de temps pour recevoir mes lunettes ?", a: "Dans la plupart des cas, quelques jours ouvrés. Pour des verres particuliers ou des traitements spéciaux, les délais peuvent varier : nous vous donnons toujours une date précise à la commande." },
    { q: "Avez-vous des lunettes pour enfants ?", a: "Oui, nous sommes spécialisés dans les verres ophtalmiques pour les plus petits et certifiés pour la gestion de la myopie avec les verres Stellest. Nous suivons chaque enfant dans le temps, avec des contrôles réguliers." },
    { q: "Puis-je commander en ligne et retirer en boutique ?", a: "Oui : choisissez les modèles dans la vitrine, confirmez la commande sur WhatsApp et passez les retirer quand vous voulez. La livraison à domicile est aussi disponible." },
    { q: "Quels moyens de paiement acceptez-vous ?", a: "En boutique, nous acceptons espèces, carte bancaire et cartes de crédit. Pour les commandes en ligne, le paiement se fait sur WhatsApp ou au retrait." },
  ],
  book_overline: "06 · Réserver une visite",
  book_title: "Réservez votre rendez-vous.",
  book_sub: "Choisissez le jour et l'heure qui vous conviennent : vous pouvez réserver à partir de 2 jours à l'avance, pour nous permettre de bien nous organiser. Nous confirmerons votre rendez-vous au plus vite.",
  book_phone: "Téléphone",
  book_service: "Service",
  book_service_ph: "Choisir un service",
  svc_vista: "Mesure de la vue",
  svc_occhiali: "Conseil lunettes de vue",
  svc_sole: "Lunettes de soleil",
  svc_bambini: "Verres enfants · gestion myopie",
  svc_progressive: "Verres progressifs",
  svc_altro: "Autre",
  svc_lenti_prima: "Première adaptation de lentilles de contact",
  svc_lenti_controllo: "Contrôle / renouvellement de lentilles",
  book_ambito: "Pour quel besoin ?",
  book_ambito_first: "Choisissez d'abord le domaine",
  ambito_vista: "Lunettes de Vue",
  ambito_vista_sub: "Examen de la vue & lunettes",
  ambito_lenti: "Lentilles de Contact",
  ambito_lenti_sub: "Adaptation & contrôle",
  book_banner_overline: "Vos yeux entre de bonnes mains",
  book_banner_title: "Réservez votre visite.",
  book_banner_sub: "Examen de la vue, lunettes de vue ou adaptation de lentilles de contact : prenez rendez-vous et nous vous consacrerons tout le temps nécessaire.",
  book_banner_cta: "Réserver",
  spec_lenti: "Verres",
  spec_taglia: "Taille",
  book_date: "Jour",
  book_slot: "Heure",
  book_submit: "Demander un rendez-vous",
  book_sending: "Envoi en cours…",
  book_sunday: "Le dimanche nous sommes fermés : choisissez un autre jour.",
  book_monday: "Le lundi, nous sommes ouverts uniquement l'après-midi (17:30 – 20:00).",
  book_toast_ok: "Demande enregistrée ! WhatsApp s'est ouvert avec le récapitulatif : envoyez-le pour confirmer le rendez-vous.",
  book_toast_err: "Erreur lors de l'envoi. Réessayez ou appelez-nous au 0831 19 81 780.",
  privacy_note: "En envoyant, vous acceptez notre",
  privacy_link: "politique de confidentialité",
  book_consent: "J'ai lu et j'accepte le traitement de mes données pour gérer la demande de rendez-vous, conformément à la",
  tryon_btn: "Essayage virtuel",
  tryon_title: "Essayage virtuel",
  tryon_sub: "Voyez comment elles vous vont :",
  tryon_use_camera: "Prendre un selfie",
  tryon_use_upload: "Télécharger une photo",
  tryon_capture: "Capturer",
  tryon_cancel: "Annuler",
  tryon_start: "Voir les lunettes sur moi",
  tryon_change: "Changer de photo",
  tryon_loading: "L'IA applique les lunettes sur votre visage… cela peut prendre une minute.",
  tryon_retry: "Essayer une autre photo",
  tryon_done: "Terminé",
  tryon_mode_single: "Ce modèle",
  tryon_mode_compare: "Comparer les montures",
  tryon_pick_sub: "Choisissez 2 à 4 montures à essayer ensemble sur votre visage :",
  tryon_pick_min: "Sélectionnez au moins 2 montures à comparer",
  tryon_compare_start: "Comparer sur mon visage",
  tryon_compare_loading: "L'IA applique toutes les montures sur votre visage... cela peut prendre environ une minute.",
  tryon_download: "Télécharger",
  tryon_added: "Ajouté au panier",
  tryon_error: "Essayage virtuel échoué. Réessayez avec une autre photo.",
  tryon_camera_err: "Caméra non disponible : téléchargez une photo.",
  tryon_privacy: "Votre photo sert uniquement à générer l'aperçu et n'est jamais enregistrée ni partagée.",
  tryon_result_alt: "Aperçu des lunettes sur votre visage",
  hl_1: "Optométristes certifiés",
  hl_2: "Spécialistes de l'optique enfant",
  hl_3: "Verres progressifs",
  hl_4: "Marques de niche",
  chi_overline: "Qui sommes-nous",
  chi_photo_alt: "Les propriétaires de Stylottica Ceglie dans leur boutique",
  v2_nav_collezioni: "Collections",
  v2_nav_storia: "Notre histoire",
  v2_nav_prodotti: "Produits",
  v2_nav_contatti: "Contact",
  v2_hero_overline: "Optique · Ceglie Messapica",
  v2_hero_suffix: " · depuis 2012",
  v2_hero_title: "L'art de bien voir.",
  v2_hero_sub: "Au cœur blanc de Ceglie Messapica, depuis 2012 : des lunettes de soleil de caractère à choisir aussi en ligne, et un soin de la vue qui se construit ensemble, avec calme, sur rendez-vous.",
  v2_hero_cta: "Découvrir les collections",
  v2_coll_overline: "Les collections",
  v2_coll_sole_desc: "Protection UV totale et du caractère à revendre. Choisissez-les en ligne et retirez-les en boutique — ou nous vous les livrons à domicile.",
  v2_coll_vista_desc: "La vue est une chose sérieuse : elle se mesure avec calme, avec les bons instruments. Réservez votre visite et construisons vos verres ensemble.",
  v2_scopri: "Découvrir",
  v2_storia_overline: "Notre histoire",
  v2_storia_title: "Treize ans de regards.",
  v2_storia_p1: "Tout a commencé il y a treize ans, dans une rue du centre de Ceglie Messapica. Depuis, chaque jour, nous accueillons ceux qui entrent comme en famille : d'abord nous écoutons vos journées, vos yeux, vos habitudes — puis nous conseillons. Parce que la bonne paire de lunettes change la façon dont vous voyez le monde, et dont le monde vous voit.",
  v2_storia_p2: "Nous sommes optométristes certifiés et Centre Optique Expert Specialist Essilor. Nous prenons soin de la vue des plus petits avec la gestion certifiée de la myopie et les verres Stellest, nous fabriquons des verres progressifs sur mesure pour vos journées et nous choisissons des marques de niche que vous ne trouvez pas ailleurs — avec le même soin que si nous choisissions pour nous.",
  v2_quote: "Professionnalisme et empathie règnent ici.",
  v2_mission_label: "Notre mission",
  v2_mission: "Des lunettes pour ceux qui choisissent d'être uniques. Jamais low cost, jamais ennuyeux.",
  v2_stat1: "Années d'activité",
  v2_stat2: "Certifications optiques",
  v2_stat3: "Sur Google",
  v2_prod_overline: "Les produits",
  v2_prod_sub: "Nos lunettes de soleil, choisies une à une parmi les marques de niche que nous aimons : commandez en ligne et passez les retirer quand vous voulez, ou écrivez-nous sur WhatsApp. Pour les lunettes de vue, en revanche, on se voit en personne — votre vue mérite plus qu'un clic.",
  v2_prod_cta: "Demander la disponibilité",
  v2_coll_overline: "Les collections",
  v2_coll_instore: "Uniquement en boutique",
  v2_empty: "La vitrine se remplit. Revenez bientôt.",
  v2_show_all: "Voir tous les produits",
  v2_show_less: "Voir moins",
  v2_version1: "Version 1",
  v2_version2: "Version 2",
};
